import { LOGOUT_USER, SET_USER, UPDATE_USER } from "../actions/type";
import { removeToken, setToken } from "../../redux/actions/";

const initialState = {
  isAuthenticated: false,
  // id : null,
  uuid: null,
  first_name: null,
  last_name: null,
  email: null,
  mobile: null,
  phone: null,
  gender: "m",
  address: null,
  postal_code: null,
  photo: null,
  reagent: null,
  level: 0,
  score: 0,
  referred_no: null,
  referred_code: null,
  apiToken: null,
  //user extra info
  extra_id: null,
  brand_id: null,
  city_id: null,
  position: null,
  mobile_verified: null,
  email_verified: null,
  birthday: null,
  marital_state: null,
  employment_state: null,
};

export default function user(state = initialState, action = {}) {
  switch (action.type) {
    case SET_USER:
      const { user } = action;
      setToken(user["api_token"]);
      /*return {
                ...user,
                apiToken : user.api_token,
            };*/
      return {
        isAuthenticated: true,
        // id : user.id,
        uuid: user.uuid,
        first_name: user.first_name,
        last_name: user.last_name,
        email: user.email,
        mobile: user.mobile,
        phone: user.phone,
        gender: user.gender,
        address: user.address,
        postal_code: user.postal_code,
        photo: user.photo,
        reagent: user.reagent,
        level: parseInt(user.level),
        score: parseInt(user.score),
        referred_no: user.referred_no,
        referred_code: user.referred_code,
        apiToken: user["api_token"],
        //user extra info
        extra_id: user["usersExtra"].id,
        brand_id: user["usersExtra"].brand_id,
        city_id: +user["usersExtra"].city_id,
        position: user["usersExtra"].position,
        mobile_verified: user["usersExtra"].mobile_verified,
        email_verified: user["usersExtra"].email_verified,
        birthday: user["usersExtra"].birthday,
        marital_state: user["usersExtra"].marital_state,
        employment_state: user["usersExtra"].employment_state,
      };
    case UPDATE_USER:
      const { newUser } = action;
      return newUser;
    case LOGOUT_USER:
      removeToken();
      return initialState;
    default:
      return state;
  }
}
